import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * The section was renamed to Keywords. Links out of reports and anything a user
 * bookmarked still point here, so the old path stays as a redirect rather than
 * a 404 — the date range in the URL travels with it.
 */
export const Route = createFileRoute('/_app/$org/$host/queries')({
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/$org/$host/keywords', params, search, replace: true })
  },
})
